export default "__VITE_ASSET__BSF7mCAa__"